/**
 * WOM Configuration — Flicker
 * API: https://api.thewordofmouth.in/api/reviews/flicker/the-home-posts
 */

var FLICKER_COMPANY_ID = 'flicker';
var FLICKER_DEFAULT_PRODUCT_SLUG = 'the-home-posts';

/** Flicker 360° ™ + Training series App — legacy WOM product (reviews with images). */
var KICKR_360_REVIEWS_API =
  'https://api.thewordofmouth.in/api/reviews/300/kickr_360_trainer_annual_training_program1';

var KICKR_360_SHOPIFY_HANDLES = ['kickr-360-trainer-™-annual-training-program'];

function normalizeProductHandle(handle) {
  return String(handle || '')
    .toLowerCase()
    .normalize('NFKC')
    .replace(/™/g, '')
    .replace(/\s+/g, '-');
}

function isKickr360TrainerProduct(handle, title) {
  var h = normalizeProductHandle(handle);
  var i;
  for (i = 0; i < KICKR_360_SHOPIFY_HANDLES.length; i++) {
    if (normalizeProductHandle(KICKR_360_SHOPIFY_HANDLES[i]) === h) {
      return true;
    }
  }

  if (h.indexOf('kickr') !== -1 && h.indexOf('360') !== -1 && h.indexOf('training') !== -1) {
    return true;
  }

  var t = String(title || '').toLowerCase();
  if (t.indexOf('flicker 360') !== -1 && t.indexOf('training') !== -1) {
    return true;
  }

  return false;
}

function isHomePage() {
  var path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
  return path === '/';
}

/**
 * Homepage + Flicker 360 trainer PDP → KICKR reviews API (has setup images).
 * Other product pages use flicker/{handle}.
 */
function getReviewsApiUrl() {
  if (isHomePage()) {
    return KICKR_360_REVIEWS_API;
  }

  var handle = getProductHandle();
  var title = getProductTitle();

  if (isKickr360TrainerProduct(handle, title)) {
    return KICKR_360_REVIEWS_API;
  }

  return undefined;
}

function getProductTitle() {
  if (
    typeof window.ShopifyAnalytics !== 'undefined' &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.title
  ) {
    return window.ShopifyAnalytics.meta.product.title.trim();
  }

  var selectors = ['h2', 'h1[itemprop="name"]', '.product-details h1', '.product-details h2', 'h1'];
  var i;
  for (i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    if (el && el.textContent) {
      return el.textContent.trim().replace(/\s+/g, ' ');
    }
  }

  var ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && ogTitle.content) {
    return ogTitle.content.trim();
  }

  return 'Flicker';
}

function getProductHandle() {
  if (
    typeof window.ShopifyAnalytics !== 'undefined' &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product &&
    window.ShopifyAnalytics.meta.product.handle
  ) {
    var analyticsHandle = window.ShopifyAnalytics.meta.product.handle;
    if (analyticsHandle && analyticsHandle !== 'undefined' && String(analyticsHandle).trim()) {
      return String(analyticsHandle).trim();
    }
  }

  var pathname = window.location.pathname;
  var parts = pathname.split('/');
  var productIndex = parts.indexOf('products');

  if (productIndex !== -1 && productIndex + 1 < parts.length) {
    return parts[productIndex + 1].split('?')[0];
  }

  return FLICKER_DEFAULT_PRODUCT_SLUG;
}

/** Collection cards: WOM overall_company keys use Shopify-style handles (hyphens). */
function getCollectionRatingSlug(handle, title) {
  if (handle && String(handle).trim()) {
    return String(handle).trim().toLowerCase();
  }
  return null;
}

const vesselsWOMConfig = {
  name: 'Flicker',

  apiBaseUrl: 'https://api.thewordofmouth.in',
  companyId: FLICKER_COMPANY_ID,

  getProductTitle: getProductTitle,
  getProductHandle: getProductHandle,
  getCollectionRatingSlug: getCollectionRatingSlug,
  getReviewsApiUrl: getReviewsApiUrl,
  reviewsApiUrl: getReviewsApiUrl,
  defaultProductSlug: FLICKER_DEFAULT_PRODUCT_SLUG,
  fixedProductSlug: FLICKER_DEFAULT_PRODUCT_SLUG,

  collectionApiUrl: 'https://api.thewordofmouth.in/api/flicker/',
  overallCompanyApiUrl: 'https://api.thewordofmouth.in/api/overall_company/flicker',
  brandReviewsApiUrl: 'https://api.thewordofmouth.in/api/brand-reviews/flicker',

  useLocalData: false,
  localDataUrl: '/assets/wom-product-data.json',

  debug: false,

  colors: {
    primary: '#000000',
    accent: '#000000',
    background: '#ffffff',
    text: '#111111',
    textLight: '#666666',
    border: '#e5e7eb',
    success: '#10b981',
    starColor: '#000000'
  },

  fontFamily: 'inherit',

  spacing: {
    cardRadius: '12px',
    cardPadding: '20px',
    gap: '16px'
  },

  components: {
    socialProof: false,
    liveUsers: false,
    ratingBreakdown: true,
    reviews: true
  },

  useCompanyWideData: false,

  settings: {
    liveUpdates: false,
    showVerifiedBadge: true,
    reviewsPerPage: 4
  },

  onWriteReview: function () {},
  onLoadMore: function () {}
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  window.vesselsWOMConfig = vesselsWOMConfig;
  window.clientWOMConfig = vesselsWOMConfig;
}
